import React, { useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "../ui/hover-card";
import { cn } from "@/dentlab/src/lib/utils/cn";
import {
	ORGANIZATION_MENU_ITEMS
} from "@/dentlab/src/pages/organization/organization-menu-config";

interface OrganizationPreviewHoverCardProps {
	children: React.ReactNode;
	onAppInteraction?: () => void;
}

export const OrganizationPreviewHoverCard: React.FC<OrganizationPreviewHoverCardProps> = ({
	children,
	onAppInteraction
}) => {
	const [open, setOpen] = useState(false);

	return (
		<HoverCard openDelay={300} closeDelay={100} open={open} onOpenChange={setOpen}>
			<HoverCardTrigger asChild>{children}</HoverCardTrigger>
			<HoverCardContent side="right" align="center" className="w-80 p-0 rounded-lg bg-slate-100 -mt-2">
				{open && <HoverCardContentWithData onClose={() => setOpen(false)} onAppInteraction={onAppInteraction} />}
			</HoverCardContent>
		</HoverCard>
	);
};

const HoverCardContentWithData: React.FC<{
	onClose: () => void;
	onAppInteraction?: () => void;
}> = ({ onClose, onAppInteraction }) => {
	const navigate = useNavigate();

	const handleNavigate = (path: string) => {
		onAppInteraction?.();
		onClose();
		navigate(path);
	};

	return (
		<div className="rounded-lg overflow-hidden">
			{ORGANIZATION_MENU_ITEMS.slice(1, ORGANIZATION_MENU_ITEMS.length - 1).map((item) => (
				<div key={item.path}>
						<div
							onClick={() => handleNavigate(item.path)}
							className={cn(
								"flex items-center gap-2 px-3 py-2.5 text-sm cursor-pointer transition-colors bg-white hover:bg-slate-200",
								"border-b border-slate-200 last:border-b-0"
							)}
							aria-label={item.title}
							data-testid={`org-menu-${item.title.toLowerCase().replace(/\s/g, "-")}`}
						>
							<span className="text-gray-600">{item.icon}</span>
							<span className="font-medium text-gray-800">{item.title}</span>
						</div>
				</div>
			))}
		</div>
	);
};
